import React from "react";
import CustomSelect from "../../../CommonComponents/Select/CustomSelect";
import { Typography, FormControl, Grid } from "@mui/material";
import CommonButton from "../../../CommonComponents/CommonButton";
import CommonInput from "../../../CommonComponents/CommonInput";

const RaiseQueryModal = ({ onClose = () => {}, onSubmit = () => {} }) => {
  return (
    <Grid
      container
      spacing={0}
      sx={{
        padding: "0px",
        margin: "0px",
        width: "100%",
        height: "100%",
      }}
    >
      <Grid item xs={12}>
        <Typography
          sx={{
            fontSize: "1.6rem",
            lineHeight: "1.94rem",
            width: "34.3rem",
            height: "1.9rem",
            fontWeight: "600",
            paddingTop: "0.5rem",
            fontColor: "#505050",
            fontFamily: "Inter",
          }}
        >
          Raise Query
        </Typography>
      </Grid>
      <Grid item xs={12} sx={{ height: "33.6rem", paddingTop: "1.6rem" }}>
        <FormControl sx={{ width: "100%" }}>
          <Grid container spacing={0}>
            <Grid
              item
              xs={12}
              //   sx={{ paddingTop: "0.8rem" }}
            >
              <p
                style={{
                  fontSize: "1.4rem",
                  color: "#7C7C7C",
                  marginBottom: "0.6rem",
                }}
              >
                Claim Number
              </p>
              <input
                type="text"
                placeholder="Enter"
                style={{
                  border: "1px solid #B0B0B0",
                  // color: "#B0B0B0",
                  fontSize: "1.5rem",
                  borderRadius: "4px",
                  padding: "0.9rem",
                  width: "100%",
                  "::placeholder": { color: "red" },
                }}
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "1.2rem" }}>
              <CustomSelect
                label="Query Title"
                placeholder="Select"
                customSelectValue=""
                options={["a", "b"]}
                required
                labelFont="1.4rem"
              />
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "1.2rem" }}>
              <p
                style={{
                  fontSize: "1.4rem",
                  color: "#7C7C7C",
                  marginBottom: "0.6rem",
                }}
              >
                Remark
              </p>
              <textarea
                rows="4"
                name="description"
                placeholder="Enter Remark"
                style={{
                  border: "1px solid #B0B0B0",
                  fontSize: "1.5rem",
                  borderRadius: "4px",
                  fontFamily: "inter",
                  padding: "0.9rem",
                  width: "100%",
                  resize: "none",
                }}
              ></textarea>
            </Grid>
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width: "100%",
                paddingTop: "1.6rem",
              }}
            >
              <div style={{ width: "10.6rem", fontSize: "1.4rem" }}>
                <CommonButton
                  label="Submit"
                  smallButton={true}
                  filledButton={true}
                  onClick={onSubmit}
                />
              </div>
            </Grid>
          </Grid>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default RaiseQueryModal;
